import {Box, Button, CircularProgress, IconButton} from "@mui/material";
import {useEffect, useState} from "react";
import {FiEdit2, FiTrash2} from "react-icons/fi";
import {useLocation, useNavigate} from "react-router-dom";
import ClientForm from "../components/Clients/ClientForm";
import ClientInfo from "../components/Clients/ClientInfo";
import ClientScopesGrid from "../components/Clients/ClientScopesGrid";
import Window from "../components/Window/Window";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import DetailTabsSection from "../components/ui/DetailTabsSection";
import useApiRequest from "../hooks/useApiRequest";
import useConfirmDialog from "../hooks/useConfirmDialog";
import {useAuthPermissions, ACTIONS, RESOURCES} from "../hooks/useAuthPermissions";
import {snackbar} from "../utils/snackbar";

const ClientDetail = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const id = state?.id;

  const isNewClient = !id;

  const {data, loading, read, remove} = useApiRequest({baseUrl: `/clients`, resource: "clients"});

  const [isEditing, setIsEditing] = useState(isNewClient);
  const {can} = useAuthPermissions();
  const {confirmOpen, itemName, openDialog, handleConfirm, handleCancel} = useConfirmDialog(async () => {
    const {success} = await remove(id);
    if (!success) return;

    snackbar.success("Cliente eliminado correctamente.");
    navigate("/clients");
  });

  useEffect(() => {
    if (!isNewClient) {
      read(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleOpenDeleteDialog = () => {
    openDialog(id, data?.name || "");
  };

  return (
    <>
      <Window title={isNewClient ? "Nuevo Cliente" : "Detalles del Cliente"} backTo="/clients">
        <Box sx={{padding: 2}}>
          {loading && !isNewClient ? (
            <CircularProgress />
          ) : (
            <Box>
              <Box sx={{display: "flex", gap: 2}}>
                {isEditing ? (
                  <ClientForm
                    isNew={isNewClient}
                    refreshData={() => read(id)}
                    setIsEditing={setIsEditing}
                    initialClientData={data || {}}
                  />
                ) : (
                  <ClientInfo client={data} />
                )}

                <Box sx={{marginLeft: "auto"}}>
                  {!isNewClient &&
                    (can(ACTIONS.WRITE, RESOURCES.CLIENTS) && (
                      isEditing ? (
                        <Button variant="contained" color="primary" onClick={handleEditToggle}>
                          Cancelar
                        </Button>
                      ) : (
                        <IconButton aria-label="edit" color="primary" onClick={handleEditToggle}>
                          <FiEdit2 />
                        </IconButton>
                      )
                    ))}
                  {!isNewClient && can(ACTIONS.DELETE, RESOURCES.CLIENTS) && (
                    <IconButton aria-label="delete" color="secondary" onClick={handleOpenDeleteDialog}>
                      <FiTrash2 />
                    </IconButton>
                  )}
                </Box>
              </Box>
            </Box>
          )}
        </Box>

        {!isNewClient && <DetailTabsSection tabs={[{label: "Scopes", content: <ClientScopesGrid clientId={id} />}]} />}
      </Window>

      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        entityName="cliente"
        entityLabel={itemName}
      />
    </>
  );
};

export default ClientDetail;
